<template>
  <v-navigation-drawer
    v-model="inputValue"
    fixed
    temporary
  >
    <div class="pa-3">
      <v-img
        :src="require('@/assets/logo.png')"
        width="120"
      />
    </div>

    <v-list>
      <v-list-group
        v-for="(item, i) in items"
        :key="i"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
        <component
          :is="`core-partials-${item.children}`"
          v-if="item.children"
        />
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  export default {
    computed: {
      items () {
        return this.$store.state.items
      },
      inputValue: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('setDrawer', val)
        }
      }
    }
  }
</script>
